module.exports = __webpack_public_path__ + "static/media/woman_with_coffee_illust.620f3eca.png";